module.exports = __webpack_public_path__ + "static/media/oidis400_seqfileicon.8ac69185.ico";